import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { normalizeAddressFailed, normalizeAddressSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* normalizeAddress(action) {
  try {
    const url = `${BACKEND_URL_V2}/proxy/backend/api/v1/helpers/normalize-address`;
    const dataResponse = yield makeRequest(url, {
      address: action.payload,
    }, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(normalizeAddressSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(normalizeAddressFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(normalizeAddressFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
